const mobile = window.matchMedia("(max-width: 992px)");

function initArchive(root) {
	const form = document.getElementById("product-archive-form");
	const results = root.querySelector(".product-archive-results");
	const count = root.querySelector(".product-archive-count");
	const search = root.querySelector('.product-archive-search input');
	const toggle = root.querySelector(".product-archive-toggle");
	let controller;
	let timer;

	const params = (page = 1) => {
		const data = new URLSearchParams(new FormData(form));
		if (!data.get("zoek")) data.delete("zoek");
		if (page > 1) data.set("pg", page);
		return data;
	};

	const updateFacets = (facets) => {
		root.querySelectorAll(".product-archive-group[data-taxonomy]").forEach((group) => {
			const counts = facets[group.dataset.taxonomy] || {};
			group.querySelectorAll(".product-archive-option-count").forEach((el) => {
				const value = counts[el.dataset.slug] || 0;
				el.textContent = `(${value})`;
				el.closest(".product-archive-option").classList.toggle("is-empty", value === 0);
			});
		});
	};

	const load = async (page = 1, { push = true, scroll = false } = {}) => {
		controller?.abort();
		controller = new AbortController();

		const query = params(page);
		query.set("action", "roots_products");
		query.set("base", root.dataset.base || "");

		root.classList.add("is-loading");

		try {
			const response = await fetch(`${root.dataset.ajax}?${query}`, { signal: controller.signal });
			const json = await response.json();
			if (!json.success) throw new Error("request failed");

			results.innerHTML = json.data.html;
			count.textContent = json.data.count;
			updateFacets(json.data.facets);

			if (push) history.pushState({ productArchive: true }, "", json.data.url);
			if (scroll) results.scrollIntoView({ behavior: "smooth", block: "start" });
		} catch (error) {
			if (error.name !== "AbortError") window.location.href = `${form.action}?${params(page)}`;
			return;
		}

		root.classList.remove("is-loading");
	};

	form.addEventListener("submit", (event) => {
		event.preventDefault();
		load();
	});

	root.addEventListener("change", (event) => {
		if (event.target.matches('input[type="checkbox"]')) load();
	});

	search?.addEventListener("input", () => {
		clearTimeout(timer);
		timer = setTimeout(() => load(), 350);
	});

	search?.addEventListener("keydown", (event) => {
		if (event.key !== "Enter") return;
		event.preventDefault();
		clearTimeout(timer);
		load();
	});

	results.addEventListener("click", (event) => {
		const link = event.target.closest(".product-pagination a[data-page]");
		if (!link) return;
		event.preventDefault();
		load(Number(link.dataset.page), { scroll: true });
	});

	root.querySelector(".product-archive-reset")?.addEventListener("click", (event) => {
		event.preventDefault();
		root.querySelectorAll('.product-archive-option input:checked').forEach((input) => (input.checked = false));
		if (search) search.value = "";
		load();
	});

	root.querySelectorAll(".product-archive-more").forEach((button) => {
		button.addEventListener("click", () => {
			const group = button.closest(".product-archive-group");
			const expanded = group.classList.toggle("is-expanded");
			button.setAttribute("aria-expanded", expanded ? "true" : "false");
			button.querySelector(".product-archive-more-label").textContent = expanded ? button.dataset.less : button.dataset.more;
		});
	});

	const setHidden = (hidden) => {
		root.classList.toggle("is-filters-hidden", hidden);
		toggle?.setAttribute("aria-pressed", hidden ? "true" : "false");
	};

	toggle?.addEventListener("click", () => setHidden(!root.classList.contains("is-filters-hidden")));
	setHidden(mobile.matches);
	mobile.addEventListener("change", () => setHidden(mobile.matches));

	window.addEventListener("popstate", () => {
		const url = new URL(window.location.href);
		root.querySelectorAll(".product-archive-option input").forEach((input) => {
			input.checked = url.searchParams.getAll(input.name).includes(input.value);
		});
		if (search) search.value = url.searchParams.get("zoek") || "";
		load(Number(url.searchParams.get("pg")) || 1, { push: false });
	});
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".product-archive").forEach(initArchive);
});
